module.exports = __webpack_public_path__ + "img/menu.b1018f75.svg";